import type { EstateTaxForm } from '@/modules/estatetaxform/models/EstateTaxForm';
import { EstateTaxFormMetaType } from '@/modules/estatetaxform/constants/EstateTaxFormMetaType';
import { EstateTaxFormCanadaMeta } from '@/modules/estatetaxform/models/meta/EstateTaxFormCanadaMeta';
import { EstateTaxFormUsMeta } from '@/modules/estatetaxform/models/meta/EstateTaxFormUsMeta';

export class EstateTaxFormMeta {
  static factory(
    model: Partial<EstateTaxForm> = {},
    meta: Partial<EstateTaxFormCanadaMeta | EstateTaxFormUsMeta> = {}
  ): EstateTaxFormCanadaMeta | EstateTaxFormUsMeta | null {
    switch (model.metaType) {
      case EstateTaxFormMetaType.ESTATE_TAX_FORM_CANADA_META:
        return EstateTaxFormCanadaMeta.mapModel({ ...model.meta, ...meta });
      case EstateTaxFormMetaType.ESTATE_TAX_FORM_US_META:
        return EstateTaxFormUsMeta.mapModel({ ...model.meta, ...meta });
      default:
        return null;
    }
  }
}
